export default __webpack_public_path__ + "static/media/img.ec552b00.png";